import { ReactComponent as HelpIcon } from "../img/icons/help.svg";
import styles from "../css/HintBox.module.css";

const HintBox = ({text}) => {
  return (
    <div className={styles.hintContainer}>
      <HelpIcon className={styles.helpIcon} />
      <p>
        {text}
      </p>
    </div>
  );
};

export default HintBox;
